module.exports = __webpack_public_path__ + "2021525:777057f5211ffb5bd912/img/hero-sq@2x.b1bd87a.jpg";